import { Directive, EventEmitter, Input, Output } from '@angular/core';

import { ListItem, ListProperty } from '@site-mate/dashpivot-shared-library';

@Directive()
export abstract class ListFieldBaseComponent {
  @Input() item: ListItem;
  @Input() property: ListProperty;
  @Input() editable = true;
  @Input() companyId?: string;
  @Input() projectId?: string;
  @Input() listId: string;
  @Output() readonly propertyUpdated = new EventEmitter<Record<string, any>>();

  abstract getPropertyValue(): any;

  abstract onPropertyUpdated(value: any): void;
}
